import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { usePurchaseContentCreditsModal } from 'hooks/usePurchaseContentCreditsModal'
import { useRetryMessage } from 'hooks/queries/chat/useRetryMessage'
import { Text } from 'blaze-ui/Text/Text'
import { InsufficientCreditsContentProps } from '../Types'
import { Button } from 'blaze-ui/Button'
import { CreditUsageButton } from 'blaze-ui/CreditUsageButton/CreditUsageButton'
import Styles from './InsufficientCreditsContent.module.scss'

export const InsufficientCreditsContent = observer(({ content, message }: InsufficientCreditsContentProps) => {
  const { tierUsageStore } = useRootStore()
  const { autopilotAddOns, currentSubscription } = tierUsageStore
  const isTrialing = currentSubscription?.status === 'trialing'

  const autopilotContentCreditsAddon = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )
  const autopilotContentCreditsPrice = autopilotContentCreditsAddon?.prices[0]

  const openPurchaseModal = usePurchaseContentCreditsModal()
  const { mutate: retryMessage } = useRetryMessage()

  const handleAddCredits = () => {
    if (autopilotContentCreditsPrice) {
      openPurchaseModal(
        {
          price: autopilotContentCreditsPrice,
          onSuccess: () => {
            retryMessage({ threadId: message.thread_id, id: message.id })
          },
          skipRedirect: true,
        },
        { newStack: true },
      )
    }
  }

  return (
    <div className={Styles.insufficientCreditsContent}>
      <Text variant="secondary">
        You don't have enough credits to complete this request. {isTrialing ? 'Upgrade' : 'Add more'} to continue.
      </Text>
      {autopilotContentCreditsPrice &&
        (isTrialing ? (
          <Button size="md" variant="primary" onPress={handleAddCredits} className={Styles.upgradeButton}>
            Upgrade
          </Button>
        ) : (
          <CreditUsageButton
            size="md"
            variant="primary"
            onPress={handleAddCredits}
            className={Styles.addCreditsButton}
            credits={content.credits_required}
          >
            Add Credits
          </CreditUsageButton>
        ))}
    </div>
  )
})
